import { useRef } from "react";
import { Bold, Heading2, Italic, List } from "lucide-react";

const TOOLS = [
  { id: "bold", icon: Bold, label: "Gras", wrap: "**" },
  { id: "italic", icon: Italic, label: "Italique", wrap: "*" },
  { id: "list", icon: List, label: "Liste à puces", prefix: "- " },
  { id: "heading", icon: Heading2, label: "Intertitre", prefix: "## " },
];

export default function RichTextEditor({ id, testId, value, onChange, rows = 6, placeholder, className }) {
  const ref = useRef(null);

  const apply = (tool) => {
    const el = ref.current;
    const { selectionStart: s, selectionEnd: e } = el;
    let next, cursor;
    if (tool.wrap) {
      const sel = value.slice(s, e) || tool.label.toLowerCase();
      next = value.slice(0, s) + tool.wrap + sel + tool.wrap + value.slice(e);
      cursor = [s + tool.wrap.length, s + tool.wrap.length + sel.length];
    } else {
      const start = value.lastIndexOf("\n", s - 1) + 1;
      const block = value.slice(start, e).split("\n").map((l) => (l.startsWith(tool.prefix) ? l.slice(tool.prefix.length) : tool.prefix + l)).join("\n");
      next = value.slice(0, start) + block + value.slice(e);
      cursor = [start, start + block.length];
    }
    onChange(next);
    requestAnimationFrame(() => { el.focus(); el.setSelectionRange(...cursor); });
  };

  return (
    <div>
      <div className="mb-1.5 flex flex-wrap items-center gap-1">
        {TOOLS.map((t) => (
          <button key={t.id} type="button" title={t.label} aria-label={t.label} data-testid={`${testId}-tool-${t.id}`} onClick={() => apply(t)}
            className="rounded-lg border border-amber-900/15 bg-white p-1.5 text-bark-soft transition-colors hover:border-amber-deep hover:text-amber-deep">
            <t.icon size={15} />
          </button>
        ))}
        <span className="ml-2 text-xs text-bark-soft">Entrée = retour à la ligne · ligne vide = nouveau paragraphe</span>
      </div>
      <textarea ref={ref} id={id} data-testid={testId} rows={rows} value={value} onChange={(e) => onChange(e.target.value)} className={`${className} resize-y`} placeholder={placeholder} />
    </div>
  );
}
